import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Heading, List, ListItem } from '@thd-olt-component-react/core-ui'
import { useConfigService } from '@thd-nucleus/experience-context';

export const Home = () => {
  const isPepRouteEnabled = useConfigService('fs:isPepRouteEnabled');

  return (
    <div className="grid isBound u--padding">
      <Helmet>
        <title>Home Page</title>
        <link rel="canonical" href="https://www.homedepot.com/" />
      </Helmet>
      <div className="sui-p-2">
        <Heading title="Browse" />
        <List type="round">
          <ListItem link><a href="/b/Appliances-Refrigerators/N-5yc1vZc3pi?debug=true">Refrigerators</a></ListItem>
          <ListItem link><a href="/b/Appliances-Washers-Dryers/N-5yc1vZc3ol?debug=true">Washers & Dryers</a></ListItem>
          <ListItem link><a href="/b/Appliances-Dishwashers/N-5yc1vZc3po?debug=true">Dishwashers</a></ListItem>
          <ListItem link><a href="/b/Appliances-Ranges/N-5yc1vZc3o9?debug=true">Ranges</a></ListItem>
          <ListItem link><a href="/b/Appliances-Wall-Ovens/N-5yc1vZc3nq?debug=true">Wall Ovens</a></ListItem>
        </List>
      </div>
      <div className="sui-p-2">
        <Heading title="Search" />
        <List type="round">
          <ListItem link>
            <a href="/s/french%2520door%2520refrigerators?debug=true">
              French Door Refrigerators
            </a>
          </ListItem>
          <ListItem link><a href="/s/top%2520load%2520washers?debug=true">Top Load Washers</a></ListItem>
          <ListItem link><a href="/s/electric%2520dryers?debug=true">Dishwashers</a></ListItem>
          <ListItem link><a href="/s/microwaves?debug=true">Ranges</a></ListItem>
        </List>
      </div>
      <div className="sui-p-2">
        <Heading title="Product Information Page" />
        <List type="round">
          <ListItem link><a href="/p/306750351?debug=true">LG French Door Smart Refrigerator</a></ListItem>
          <ListItem link><a href="/p/205343862?debug=true">LG Side by Side Refrigerator (Discontinued)</a></ListItem>
          <ListItem link><a href="/p/311972517?debug=true">GE Front Load Washing Machine</a></ListItem>
          <ListItem link><a href="/p/309171868?debug=true">Samsung Top Load Washing Machine</a></ListItem>
          <ListItem link><a href="/p/304789505?debug=true">GE Stainless Steel Dishwasher</a></ListItem>
          <ListItem link><a href="/p/319923622?debug=true">Base Bespoke Item</a></ListItem>
          {/* eslint-disable-next-line max-len */}
          <ListItem link><a href="/p/Samsung-BESPOKE-French-Door-Smart-Refrigerator-with-Customizable-Panels/317168928?60694-Counter&103288-3-Door-French-Door&99775-Autofill-Water-Pitcher&60654-White-Glass&62857-White-Glass&60662-White-Glass">Bespoke Product Configurator</a></ListItem>
        </List>
      </div>
      {
        isPepRouteEnabled
        && (
          <div className="sui-p-2">
            <Heading title="Product Entry Page" />
            <List type="round">
              <ListItem link><a href="/pep/306750351?debug=true">LG French Door Smart Refrigerator</a></ListItem>
              <ListItem link>
                <a href="/pep/205343862?debug=true">LG Side by Side Refrigerator (Discontinued)</a>
              </ListItem>
              <ListItem link><a href="/pep/311972517?debug=true">GE Front Load Washing Machine</a></ListItem>
              <ListItem link><a href="/pep/309171868?debug=true">Samsung Top Load Washing Machine</a></ListItem>
              <ListItem link><a href="/pep/304789505?debug=true">GE Stainless Steel Dishwasher</a></ListItem>
              <ListItem link><a href="/pep/319923622?debug=true">Base Bespoke Item</a></ListItem>
              {/* eslint-disable-next-line max-len */}
              <ListItem link><a href="/pep/Samsung-BESPOKE-French-Door-Smart-Refrigerator-with-Customizable-Panels/317168928?60694-Counter&103288-3-Door-French-Door&99775-Autofill-Water-Pitcher&60654-White-Glass&62857-White-Glass&60662-White-Glass">Bespoke Product Configurator</a></ListItem>
            </List>
          </div>
        )
      }
    </div>
  );
};

Home.propTypes = {};

Home.defaultProps = {};
